module.exports = __webpack_public_path__ + "img/marinasquare_logo.50c42457.jpg";